




























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import PlainTextLayerDrawer from '../plainTextLayerDrawer/plainTextLayerDrawer.vue';
import SimpleTextLayerDrawer from '../simpleTextLayerDrawer/simpleTextLayerDrawer.vue';
import SimpleTextLayerDrawerV from '../simpleTextLayerDrawerV/simpleTextLayerDrawerV.vue';
import CircleTextLayerDrawer from '../circleTextLayerDrawer/circleTextLayerDrawer.vue';
import D3TextLayerDrawer from '../d3TextLayerDrawer/d3TextLayerDrawer.vue';
import DateTextLayerDrawer from '../dateTextLayerDrawer/dateTextLayerDrawer.vue';
import NumberLayerDrawer from '../numberLayerDrawer/numberLayerDrawer.vue';
import RasterImageLayerDrawer from '../rasterImageLayerDrawer/rasterImageLayerDrawer.vue';
import VectorImageLayerDrawer from '../vectorImageLayerDrawer/vectorImageLayerDrawer.vue';
import LineLayerDrawer from '../lineLayerDrawer/lineLayerDrawer.vue';
import CurveLayerDrawer from '../curveLayerDrawer/curveLayerDrawer.vue';
import TableLayerDrawer from '../tableLayerDrawer/tableLayerDrawer.vue';
import BarcodeLayerDrawer from '../barcodeLayerDrawer/barcodeLayerDrawer.vue';
import QRcodeLayerDrawer from '../qrcodeLayerDrawer/qrcodeLayerDrawer.vue';
import RectangleLayerDrawer from '../rectangleLayerDrawer/rectangleLayerDrawer.vue';
import CircleLayerDrawer from '../circleLayerDrawer/circleLayerDrawer.vue';
import PolygonLayerDrawer from '../polygonLayerDrawer/polygonLayerDrawer.vue';
import SpecialPatternLayerDrawer from '../specialPatternLayerDrawer/specialPatternLayerDrawer.vue';
import CalendarLayerDrawer from '../calendarLayerDrawer/calendarLayerDrawer.vue';

import * as def from '@/definitions'
// TODO document2
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { GroupLayer } from '@/model/document2/page/surface/design/layer/groupLayer';
@Component({
    components: {
        PlainTextLayerDrawer,
        SimpleTextLayerDrawer,
        SimpleTextLayerDrawerV,
        CircleTextLayerDrawer,
        D3TextLayerDrawer,
        DateTextLayerDrawer,
        NumberLayerDrawer,
        RasterImageLayerDrawer,
        VectorImageLayerDrawer,
        LineLayerDrawer,
        CurveLayerDrawer,
        TableLayerDrawer,
        BarcodeLayerDrawer,
        QRcodeLayerDrawer,
        RectangleLayerDrawer,
        CircleLayerDrawer,
        PolygonLayerDrawer,
        SpecialPatternLayerDrawer,
        CalendarLayerDrawer
    },
})
export default class CommonLayerDrawer extends Vue {

    @Prop() private layer!: Layer;
    @Prop() private scale!: number;
    @Prop() private offsetX!: number;
    @Prop() private offsetY!: number;
    @Prop() private isRendering!: boolean;
    // 直接印刷ではクライアントで処理するのでサーバー用のフォントになると困る
    @Prop({default : false}) private isRenderingOnClient!: boolean;
    @Prop({default : true}) private isFontLoaded! : boolean;
    // エディット対象かどうか？
    // 編集面選択に表示されている場合は、キャレットとプレースホルダを表示しないため
    @Prop({ default: false }) private isInEditor! : boolean;
    @Watch('isFontLoaded')
    onFontLoadedChanged(val: boolean, oldVal: boolean)
    {
        if(val && !oldVal)
        {
            this.updateView();
        }
    }

    // レイヤー移動・拡大縮小中の描画省略判定
    @Prop({ default: 0 }) private useSimpleText! : number;
    @Prop({ default: 0 }) private moveLayerMode! : number;
    @Prop({ default: "" }) private moveLayerId! : string;

    private isUpdateView = true;
    private updateView()
    {
        this.isUpdateView = false;
        this.$nextTick(() =>
        {
            this.isUpdateView = true;
        });
    }
}
